import { render } from "./ProductsImportsTableCard.vue?vue&type=template&id=5f083aa2"
import script from "./ProductsImportsTableCard.vue?vue&type=script&lang=js"
export * from "./ProductsImportsTableCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__